exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-3b884edb],h2[data-v-3b884edb]{font-weight:400}ul[data-v-3b884edb]{list-style-type:none;padding:0}li[data-v-3b884edb]{display:inline-block;margin:0 10px}a[data-v-3b884edb]{color:#42b983}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b884edb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/HelloWorld.vue
// module id = XcX3
// module chunks = 2